import React, { useEffect, useState, useRef } from "react";
import "./PersonalLoanEligibility.css";
import { useMediaQuery } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { ColorRing } from "react-loader-spinner";
import axios from "axios";
import { useContext } from "react";
import { UserContext } from "../../../ContextAPI/FormContextAPI";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { FaRupeeSign } from "react-icons/fa";

const PersonalLoanEligibility = ({ formData, setFormData, loanApplyType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [salaried, setSalaried] = useState(false);
  const [cmpList, setCmpList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [otpField, setOtpField] = useState("");
  const [show, setShow] = useState(false);
  const [cmpModal, setCmpModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [stgOne, setStgOne] = useState("");
  const [stgTwo, setStgTwo] = useState("");
  const [formId, setFormId] = useState("");
  const [termsAccepted2, setTermsAccepted2] = useState(false);
  const [errors, setErrors] = useState({});
  const [showTwo, setShowTwo] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [inputFil, setInput] = useState(false);
  const [searchElement, setSearchElement] = useState("");
  const [companyname, setCompanyName] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [Company, setCompany] = useState("");
  const [isclicked1, setIsclicked1] = useState(false);
  const [open, setOpen] = useState(false);
  const [showLessIncome, setShowLessIncome] = useState(false);
  const [isSelfEmployeed, setIsSelfEmployeed] = useState(false);
  const [isBusinessRegistered, setIsBusinessRegistered] = useState("");
  const [isBusinessProof, setIsBusinessProof] = useState("");
  const [selectedTurnover, setSelectedTurnover] = useState("Below 2L");
  const [selectedBusinessAge, setSelectedBusinessAge] =
    useState("Under 6 months");
  const [showSelfEmployee, setShowSelfEmployee] = useState(false);
  const [eligibilityUserData, setEligibilityUserData] = useState({});
  // start new form data!
  const { form2Data, setForm2Data } = useContext(UserContext);

  useEffect(() => {
    const fetchedUsersData = localStorage.getItem("eligibilityUserData");

    if (!fetchedUsersData) {
      navigate("/");
    }
    setEligibilityUserData(JSON.parse(fetchedUsersData));
  }, []);

  useEffect(() => {
    if (!form2Data.profession) {
      setForm2Data({
        city: eligibilityUserData?.city || "",
        email: eligibilityUserData?.email || "",
        fname: eligibilityUserData?.fname || "",
        lname: eligibilityUserData?.lname || "",
        mobile: eligibilityUserData?.mobile || "",
        profession: "",
        company: "",
        monthly_income: "",
        monthly_emi: "",
        loan_type: loanApplyType,
        purpose: eligibilityUserData?.purpose,
      });
    }
  }, [loanApplyType, eligibilityUserData]);

  const handleChangeInput = async (e) => {
    const { name, value } = e.target;

    if (name === "monthly_income" || name === "monthly_emi") {
      const plainNumber = parseFloat(value.replace(/,/g, ""));
      let fValue = plainNumber >= 0 ? plainNumber : "";

      setForm2Data((oldData) => ({
        ...oldData,
        [name]: fValue,
      }));
    } else if (name === "profession") {
      if (value === "Salaried") {
        setSalaried(true);
        setIsSelfEmployeed(false);
        setIsBusinessProof("");
        setIsBusinessRegistered("");
        setSelectedBusinessAge("Under 6 months");
        setSelectedTurnover("Below 2L");
        setCmpModal(true);
        const response = await axios.get(
          "https://app.minemi.ai/api/companyList"
        );

        if (response.status === 200) {
          let cmpArray = response.data.data.company;
          const formattedOptions = cmpArray.map((option) => ({
            value: option.id,
            label: option.company_name,
          }));
          setCmpList(formattedOptions);
        }
        setCmpModal(false);
      } else if (value === "Self-Employed") {
        setIsSelfEmployeed(true);
        setSalaried(false);
      } else {
        setSalaried(false);
        setIsSelfEmployeed(false);
        setIsBusinessProof("");
        setIsBusinessRegistered("");
        setSelectedBusinessAge("Under 6 months");
        setSelectedTurnover("Below 2L");
        setCmpModal(true);
        setForm2Data((oldData) => ({
          ...oldData,
          company: "", // Reset company if profession is not "Salaried"
        }));
      }

      setForm2Data((oldData) => ({
        ...oldData,
        [name]: value,
      }));
    } else {
      setForm2Data((oldData) => ({
        ...oldData,
        [name]: value,
      }));
    }
  };
  const handleSubmitForm = async (event) => {
    event.preventDefault();
    gtag_report_conversion();
    setValidated(true);

    // Validate all required fields
    if (
      !eligibilityUserData?.fname ||
      !eligibilityUserData?.lname ||
      !eligibilityUserData?.email ||
      !eligibilityUserData?.mobile ||
      !form2Data.profession ||
      form2Data.profession === "Your profession" ||
      !form2Data.monthly_income ||
      !termsAccepted2 ||
      (isSelfEmployeed && isBusinessProof === "") ||
      (isSelfEmployeed && isBusinessRegistered === "")
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (salaried && !form2Data.company) {
      toast.error("Please select your company.");
      return;
    }

    if (
      (isSelfEmployeed && isBusinessProof === "No") ||
      (isSelfEmployeed && isBusinessRegistered === "No") ||
      (isSelfEmployeed && selectedTurnover === "Below 2L") ||
      (isSelfEmployeed && selectedBusinessAge === "Under 6 months")
    ) {
      return setShowSelfEmployee(true);
    } else {
      setShowSelfEmployee(false);
      if (form2Data.monthly_income < 35000) {
        return setShowLessIncome(true);
      } else {
        setShowLessIncome(false);
        try {
          setLoader(true);
          const response = await axios.post(
            "https://loanapi.minemi.ai/api/login",
            form2Data
          );

          if (response.status === 200) {
            if (response.data.status === 1) {
              setStgOne(response.data.data.expData.stgOneHitId);
              setStgTwo(response.data.data.expData.stgTwoHitId);
              setFormId(response.data.data.formId);
              setShow(true);
            } else {
              toast.success(response?.data?.msg);
            }
          }
          setLoader(false);
        } catch (error) {
          console.error("Error making POST request", error);
          setLoader(false);
          toast.error("Something went wrong. Please try again later.");
        }
      }
    }
  };
  const otpSubmit = async () => {
    setOtpLoader(true);
    // const concatenateOtp = otpField.join("");
    if (otpField.length !== 6) {
      toast.error(
        "Please enter the 6-digit OTP sent to your registered mobile number!"
      );
      setOtpLoader(false);
    } else {
      let formData = new FormData();
      formData.append("stgOneHitId", stgOne);
      formData.append("stgTwoHitId", stgTwo);
      formData.append("otp", otpField);
      formData.append("mobile", eligibilityUserData?.mobile);
      formData.append("formId", formId);
      formData.append("type", "CUSTOM");
      try {
        const response = await axios.post(
          "https://loanapi.minemi.ai/api/verifyOtp",
          formData
        );
        setOtpLoader(false);
        if (response.data.status) {
          resetOtp();
          setShow(false);
          localStorage.setItem(
            "username",
            eligibilityUserData?.fname + " " + eligibilityUserData?.lname
          );
          sessionStorage.setItem("fId", formId);
          localStorage.setItem("eligibleData", JSON.stringify(response.data));

          loanApplyType === "pl"
            ? navigate("/personalloan/check-eligibility/dashboard", {
                replace: true,
                state: { isValid: true },
              })
            : loanApplyType === "cl"
            ? navigate("/carloan/check-eligibility/dashboard", {
                replace: true,
                state: { isValid: true },
              })
            : navigate("/homeloan/check-eligibility/dashboard", {
                replace: true,
                state: { isValid: true },
              });
        }

        if (!response.data.status) {
          toast.error(response.data.msg);
        }
      } catch (error) {
        console.error("Error making POST request", error);
        setOtpLoader(false);
      }
    }
  };

  const otpHandleChange = (element) => {
    let value = element.value.replace(/[^0-9]/g, "");
    value = value.slice(0, 6);
    setOtpField(value);
  };
  const resetOtp = () => {
    setOtpField("");
  };

  useEffect(() => {
    localStorage.removeItem("termData");
    localStorage.removeItem("eligibleData");
    localStorage.removeItem("username");
    sessionStorage.removeItem("fId");
    localStorage.removeItem("eligibilityUserData");
    const routeData = location.state;
    if (routeData !== null) {
      toast.warning(routeData.msg);
      navigate(location.pathname, { state: null });
    }
  }, []);

  // terms of use
  const CompanyDetail = () => {
    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_SECRET_KEY}/webData`,
    };

    axios
      .request(options)
      .then(function (response) {
        setHtmlContent(response.data.data.term_of_use);
      })
      .catch(function (error) {
        console.error(error);
      });
  };
  useEffect(() => {
    CompanyDetail();
  }, []);

  // useMediaQuery

  const smallScreen = useMediaQuery("(max-width:576px)");
  const mediumScreen = useMediaQuery("(max-width:768px)");
  const largeScreen = useMediaQuery("(max-width:992px)");
  const gtag_report_conversion = () => {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "conversion", {
        send_to: "AW-16847657594/W1BOCO3G9ZcaEPq0y-E-",
        value: 1.0,
        currency: "INR",
        event_callback: () => console.log("Conversion tracked"),
      });
      return true; // Returning true if gtag exists
    } else {
      console.error("gtag is not available");
      return false; // Returning false in case of an error
    }
  };
  const handleOptionSelect2 = (companyname) => {
    setForm2Data((prevData) => ({
      ...prevData,
      company: companyname,
    }));
    setCompanyName(companyname);
    setOpen(!open);
    setInput(!inputFil);
  };
  const handleSearch = (searchValue) => {
    const filteredResults = cmpList.filter((item) =>
      item.label?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const handleChange1 = (event) => {
    const searchValue = event.target.value;
    setSearchElement(searchValue);
    handleSearch(searchValue);
    setOpen(true);
  };

  return (
    <>
      <div id="find-home-loan">
        <div className="find-hl-eligibility-page bg-transparent">
          <div className="card-box-content ">
            <div className="find-hl-loan-get-up-card bg-transparent">
              <div className="card-content d-flex flex-column justify-content-center align-items-center gap-md-4 bg-transparent">
                <div className="few-details-text bg-transparent">
                  <div className="get-up-text bg-transparent">
                    {" "}
                    <h2 className="bg-transparent">
                      Almost There! Just Share a Few Details to Check
                      Eligibility
                    </h2>
                  </div>
                </div>

                <div
                  id="input-filds-container"
                  className="w-100 bg-transparent"
                >
                  <form
                    action=""
                    onSubmit={handleSubmitForm}
                    className="bg-transparent"
                  >
                    {" "}
                    <div
                      id="input-fields"
                      className="  d-flex flex-column justify-content-center align-items-center gap-4 w-100 bg-transparent"
                    >
                      <div className="w-100 d-flex flex-column gap-4 bg-transparent">
                        <div className="bg-transparent">
                          <Form.Select
                            // className="profession"
                            className="home-loan-eligibility-input-field"
                            // required
                            value={form2Data.profession}
                            name="profession"
                            onChange={handleChangeInput}
                          >
                            <option value="Your profession">
                              Your profession
                            </option>
                            <option value="Salaried">Salaried</option>
                            <option value="Self-Employed">Self-Employed</option>
                          </Form.Select>

                          {validated &&
                            (!form2Data.profession ||
                              form2Data.profession === "Your profession") && (
                              <p className="field-error bg-transparent">
                                Profession is required field
                              </p>
                            )}

                          {salaried && (
                            <div
                              className="home-loan-eligibility-input-field mt-4"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              onClick={() => setInput(!inputFil)}
                            >
                              {companyname == "" ? "Your Company" : companyname}
                            </div>
                          )}
                          {salaried && inputFil ? (
                            <input
                              className="home-loan-eligibility-input-field mt-4"
                              type="text"
                              placeholder="Search here"
                              onChange={handleChange1}
                            />
                          ) : null}
                          {open &&
                            (searchResults.length == 0 ? null : (
                              <div
                                className="input-boxes"
                                style={{
                                  paddingLeft: "4px",
                                  paddingRight: "4px",
                                  marginBottom: "10px",
                                  paddingTop: "10px",
                                  borderRadius: "8px",
                                  border: "1px solid rgba(132, 108, 166, 1)",
                                  backgroundColor: "rgba(132, 108, 166, 0.1)",
                                  cursor: "pointer", // Add cursor pointer for indicating clickable
                                  display: "flex",
                                  flexDirection: "column",
                                  marginTop: "4%",
                                  height: 160,
                                  overflowX: "auto",
                                }}
                              >
                                {searchResults.map((d, index) => (
                                  <div
                                    key={index}
                                    onClick={() => handleOptionSelect2(d.label)}
                                    style={{
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      color: "rgba(31, 31, 31, 1)",
                                      backgroundColor: "transparent",
                                      paddingBottom: 20,
                                    }}
                                  >
                                    {d.label}
                                  </div>
                                ))}
                              </div>
                            ))}

                          {validated && salaried && !form2Data.company && (
                            <p className="field-error bg-transparent">
                              Company name is required field
                            </p>
                          )}

                          {isSelfEmployeed && (
                            <div className="is_self_employeed px-2 pt-4 d-flex flex-column gap-4">
                              <div className="d-flex flex-column gap-2">
                                <div className="d-flex flex-row gap-2 justify-content-between align-items-center w-100 bg-transparent">
                                  <p id="is-self-employee">
                                    Is your business registered?{" "}
                                  </p>

                                  <div className="flex flex-row gap-2">
                                    <label className="flex items-center gap-1">
                                      <input
                                        type="radio"
                                        name="isBusinessRegistered"
                                        value="Yes"
                                        checked={isBusinessRegistered === "Yes"}
                                        onChange={(e) => {
                                          setIsBusinessRegistered(
                                            e.target.value
                                          );
                                        }}
                                        className="w-4 h-4"
                                      />
                                      Yes
                                    </label>

                                    <label className="flex items-center gap-1">
                                      <input
                                        type="radio"
                                        name="isBusinessRegistered"
                                        value="No"
                                        className="w-4 h-4"
                                        checked={isBusinessRegistered === "No"}
                                        onChange={(e) => {
                                          setIsBusinessRegistered(
                                            e.target.value
                                          );
                                        }}
                                      />
                                      No
                                    </label>
                                  </div>
                                </div>
                                {validated &&
                                  isSelfEmployeed &&
                                  isBusinessRegistered === "" && (
                                    <p className="field-error bg-transparent">
                                      Please select any one
                                    </p>
                                  )}
                              </div>

                              <div className="d-flex flex-column gap-2">
                                <div
                                  className="d-flex flex-row gap-2
                                 justify-content-between
                               align-items-start w-100 bg-transparent"
                                >
                                  <p id="is-self-employee">
                                    Do you have business proof documents like
                                    GST, ITR, or Form 16?
                                  </p>

                                  <div className="flex flex-row  gap-2">
                                    <label className="flex items-center gap-1">
                                      <input
                                        type="radio"
                                        name="isBusinessProof"
                                        className="w-4 h-4"
                                        value="Yes"
                                        checked={isBusinessProof === "Yes"}
                                        onChange={(e) => {
                                          setIsBusinessProof(e.target.value);
                                        }}
                                      />
                                      Yes
                                    </label>

                                    <label className="flex items-center gap-1">
                                      <input
                                        type="radio"
                                        name="isBusinessProof"
                                        className="w-4 h-4"
                                        value="No"
                                        checked={isBusinessProof === "No"}
                                        onChange={(e) => {
                                          setIsBusinessProof(e.target.value);
                                        }}
                                      />
                                      No
                                    </label>
                                  </div>
                                </div>

                                {validated &&
                                  isSelfEmployeed &&
                                  isBusinessProof === "" && (
                                    <p className="field-error bg-transparent">
                                      Please select any one
                                    </p>
                                  )}
                              </div>

                              <div
                                className="d-flex flex-column gap-3 justify-content-start
                               align-items-start w-100 bg-transparent"
                              >
                                <div>
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      lineHeight: "20px",
                                    }}
                                  >
                                    What is your average monthly turnover/sales?
                                  </p>
                                </div>
                                <select
                                  id="self-employee-average-turnover"
                                  className="home-loan-eligibility-input-field"
                                  value={selectedTurnover}
                                  onChange={(e) => {
                                    setSelectedTurnover(e.target.value);
                                  }}
                                >
                                  <option value="Below 2L">Below 2L</option>
                                  <option value="2L - 5L">2L - 5L</option>
                                  <option value="5L - 10L">5L - 10L</option>
                                  <option value="10L+">10L+</option>
                                </select>
                              </div>
                              <div
                                className="d-flex flex-column gap-3 justify-content-start
                               align-items-start w-100 bg-transparent"
                              >
                                <div>
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      lineHeight: "20px",
                                    }}
                                  >
                                    How old is your business?
                                  </p>
                                </div>
                                <select
                                  id="self-employee-business-age"
                                  className="home-loan-eligibility-input-field"
                                  value={selectedBusinessAge}
                                  onChange={(e) => {
                                    setSelectedBusinessAge(e.target.value);
                                  }}
                                >
                                  <option value="Under 6 months">
                                    Under 6 months
                                  </option>
                                  <option value="6-12 months">
                                    6-12 months
                                  </option>
                                  <option value="1-3 years">1-3 years</option>
                                  <option value="3+ years">3+ years</option>
                                </select>
                              </div>
                            </div>
                          )}
                        </div>

                        <InputGroup className="w-100 bg-transparent">
                          <InputGroup.Text className="rupee-icon ">
                            <FaRupeeSign
                              color="#59266D"
                              className="bg-transparent"
                            />
                          </InputGroup.Text>
                          <Form.Control
                            // required
                            placeholder="Your monthly income"
                            // className="home-loan-eligibility-input-field"
                            className="input-groups"
                            value={
                              form2Data.monthly_income === 0 ||
                              form2Data.monthly_income
                                ? new Intl.NumberFormat("en-IN").format(
                                    form2Data.monthly_income
                                  )
                                : ""
                            }
                            name="monthly_income"
                            onChange={handleChangeInput}
                          />
                        </InputGroup>
                        {validated && !form2Data.monthly_income && (
                          <p className="field-error bg-transparent">
                            Monthly income is required field
                          </p>
                        )}
                        {errors.monthly_income && (
                          <span>{errors.monthly_income}</span>
                        )}

                        <InputGroup className="w-100">
                          <InputGroup.Text className="rupee-icon">
                            <FaRupeeSign
                              color="#59266D"
                              className="bg-transparent"
                            />
                          </InputGroup.Text>
                          <Form.Control
                            // required
                            placeholder="Your monthly EMI"
                            // className="home-loan-eligibility-input-field"
                            className="input-groups"
                            value={
                              form2Data.monthly_emi === 0 ||
                              form2Data.monthly_emi
                                ? new Intl.NumberFormat("en-IN").format(
                                    form2Data.monthly_emi
                                  )
                                : ""
                            }
                            name="monthly_emi"
                            onChange={handleChangeInput}
                          />
                        </InputGroup>
                      </div>
                    </div>
                    <div id="check-box" className="bg-transparent">
                      <div
                        id="check-box"
                        className=" bg-transparent d-flex flex-row justify-content-start align-items-start pt-4 pt-md-4 w-100"
                      ></div>

                      <div
                        id="check-box"
                        className="d-flex flex-row justify-content-center align-items-start pt-3 w-100
                        bg-transparent"
                      >
                        <div className="bg-transparent">
                          <input
                            type="checkbox"
                            checked={termsAccepted2}
                            onChange={(e) =>
                              setTermsAccepted2(e.target.checked)
                            }
                            className="form-check-input"
                          />
                        </div>
                        <div className="bg-transparent">
                          <label
                            id="terms-privecy-para"
                            className="bg-transparent"
                          >
                            I allow MinEmi and Nine Triangles Pvt. Ltd to access
                            my credit report from RBI approved credit bureaus on
                            an ongoing basis for not exceeding 6 months. I also
                            agree to{" "}
                            <a
                              id="anker-text"
                              href="#"
                              // onClick={(e) => {
                              //   e.preventDefault();
                              //   handleClickOne("experian_consent");
                              // }}
                              onClick={() => setShowTwo(true)}
                            >
                              Experian Terms and Conditions.
                            </a>
                          </label>
                        </div>
                      </div>
                      {validated && !termsAccepted2 && (
                        <p className="field-error bg-transparent">
                          You must agree before submitting.
                        </p>
                      )}
                    </div>
                    <div id="button-box" className=" bg-transparent w-100">
                      {!loader ? (
                        <button
                          disabled={loader}
                          // onClick={() => setShow(false)}
                          // Open modal on button click
                          style={{
                            width: smallScreen
                              ? "100%"
                              : largeScreen
                              ? "100%"
                              : "70%",
                            backgroundColor: "#59266D",
                            color: "#ffff",
                            border: "none",
                            fontSize: smallScreen
                              ? "14px"
                              : mediumScreen
                              ? "18px"
                              : " 24px",
                            fontWeight: 500,
                            lineHeight: "26px",
                            borderRadius: smallScreen ? "6px" : "10px",
                            padding: smallScreen
                              ? "0.3rem 2.5rem"
                              : "0.8rem 0rem",
                            // padding: "0.8rem 0",
                            fontFamily: "'Archivo',sans-serif",
                            letterSpacing: "-0.17px",
                            textTransform: "none",
                          }}
                          variant="contained"
                        >
                          Proceed
                        </button>
                      ) : (
                        <button className="color-ring">
                          <ColorRing
                            visible={loader}
                            height="30"
                            width="30"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{ background: "transparent" }}
                            wrapperClass="color-ring-wrapper"
                            colors={[
                              "#ffffff",
                              "#ffffff",
                              "#ffffff",
                              "#ffffff",
                              "#ffffff",
                              "#ffffff",
                            ]}
                          />
                        </button>
                      )}
                    </div>{" "}
                  </form>

                  <div
                    id="experian-img"
                    className=" bg-transparent d-flex justify-content-center align-content-center pt-md-2"
                  >
                    <img
                      style={{
                        width: "122px",
                        backgroundColor: "transparent",
                      }}
                      // src={experianImg}
                      src="/Assets/Images/experian.png"
                      alt="experian-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* OTP Modal */}
        <Modal
          className="bg-transparent"
          size="lg"
          show={show}
          onHide={() => {
            setShow(false);
            resetOtp();
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <div className="row bg-transparent" id="otpCon">
              <div className="col-lg-6 px-0 bg-transparent">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/auth.webp"
                  alt="Authentication"
                />
              </div>

              <div className="col-lg-6 bg-transparent" id="otp-section">
                <div>
                  <p className="m-0 p-0 otp-text">Enter OTP</p>
                  <p className="m-0 p-0 otp-desc">
                    Please enter the one-time password (OTP) sent on the given
                    number - {eligibilityUserData?.mobile}
                  </p>
                </div>

                <div className="otp-input-con bg-transparent">
                  <input
                    type="text"
                    maxLength="6"
                    className="otp-single-input bg-transparent"
                    value={otpField}
                    onChange={(e) => otpHandleChange(e.target)}
                  />
                </div>

                <div className="otpBtn bg-transparent">
                  {!otpLoader ? (
                    <button
                      class="verify-btn"
                      disabled={otpLoader}
                      onClick={otpSubmit}
                    >
                      Verify
                    </button>
                  ) : (
                    <button className="verify-btn">
                      <ColorRing
                        visible={otpLoader}
                        height="30"
                        width="30"
                        ariaLabel="color-ring-loading"
                        wrapperStyle={{ background: "transparent" }}
                        wrapperClass="color-ring-wrapper"
                        colors={[
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                        ]}
                      />
                    </button>
                  )}
                  <button id="resend-otp" onClick={handleSubmitForm}>
                    Resend OTP
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Terms&condition Modal */}
        <Modal
          className="bg-transparent"
          size="lg"
          show={showTwo}
          onHide={() => {
            setShowTwo(false);
            // resetOtp();
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <div
              style={{
                marginLeft: "5%",
                marginRight: "5%",
                marginTop: 10,
                fontSize: "21px",
                lineHeight: "3.75rem",
                color: "rgb(89, 38, 109)",
                fontWeight: "bold",
              }}
            >
              Terms and Conditions{" "}
            </div>
            <div
              className="api-text"
              style={{ marginLeft: "5%", marginRight: "5%" }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </Modal.Body>
        </Modal>

        {/* Income Less Than 35000 Message Modal */}
        <Modal
          className="bg-transparent"
          size="lg"
          show={showLessIncome}
          onHide={() => {
            setShowLessIncome(false);
            // resetOtp();
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <div
              style={{
                marginLeft: "5%",
                marginRight: "5%",
                marginTop: 10,
                fontSize: "21px",
                lineHeight: "26px",
                color: "rgb(89, 38, 109)",
                fontWeight: "bold",
              }}
            >
              We're Currently Supporting Limited Profiles
            </div>
            <div
              className="api-text"
              style={{ marginLeft: "5%", marginRight: "5%", marginTop: "5%" }}
            >
              We appreciate your interest in Minemi. At this time, we are only
              processing applications that meet our minimum eligibility
              criteria, which includes an annual income of ₹4,00,000 or above.
              This is a temporary operational guideline and not a reflection of
              your creditworthiness. You’re welcome to check back with us in the
              future as we expand our services.
            </div>
          </Modal.Body>
        </Modal>

        {/* Self Employee Condition Fail Modal  */}
        <Modal
          className="bg-transparent"
          size="lg"
          show={showSelfEmployee}
          onHide={() => {
            setShowSelfEmployee(false);
            // resetOtp();
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <div
              style={{
                marginLeft: "5%",
                marginRight: "5%",
                marginTop: 10,
                fontSize: "21px",
                lineHeight: "26px",
                color: "rgb(89, 38, 109)",
                fontWeight: "bold",
              }}
            >
              Eligibility Criteria Not Met at This Time
            </div>
            <div
              className="api-text"
              style={{ marginLeft: "5%", marginRight: "5%", marginTop: "5%" }}
            >
              Based on the details shared, were currently unable to proceed with
              the eligibility check. You can reapply once you meet the minimum
              loan criteria.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default PersonalLoanEligibility;
